import AuthManager from "Common/AuthManager";
import { toast } from "react-toastify";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getPivotData = async (Uid: string) => {
  try {
    const ret = await ServiceWrapper.doGet(
      `${api_base_url}pivot_attribute/${Uid}`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!ret.errorfound) {
      return ret?.data?.data;
    } else return ret?.data?.message;
  } catch (error) {
    return "could'nt get the list";
  }
};

export const fetchAttributes = async (categoryId: string) => {
  try {
    const res = await ServiceWrapper.doPost(
      `${api_base_url}get_attributes?page=1&limit=500`,
      { category_ids: [categoryId] },
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      return res?.data?.data[0]?.attributes;
    } else return null;
  } catch (error) {
    return "could'nt get the attributes";
  }
};

export const fetchPivotTableData = async (industryId: string, channelKey: string, page: number, recordPerPage: number, base_categories?: string[]) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: recordPerPage.toString(),
      industry_id: industryId,
      channel_key: channelKey
    });
    if (base_categories && base_categories.length > 0) params.append('base_categories', JSON.stringify(base_categories));

    const res = await ServiceWrapper.doGet(
      `${api_base_url}pivot_attribute/list?${params.toString()}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      return res.data;
    } else return null;
  } catch (error) {
    return "could'nt get pivot attributes";
  }
};

export const savePivotData = async (saveData: SavePivotType) => {
  try {
    saveData = { ...saveData };
    const res = await ServiceWrapper.doPost(
      `${api_base_url}pivot_attribute`,
      saveData,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      return res;
    } else return "Save Unsuccessful";
  } catch (error) {
    return "Save Unsuccessful";
  }
};

export const updatePivotData = async (data: UpdatePivotType) => {
  try {
    const res = await ServiceWrapper.doPut(
      `${api_base_url}/pivot_attribute/${data?.uid}`,
      data,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res?.data?.done) {
        return res;
      } else return res?.data?.message;
    }
  } catch (error) {
    return "Update Unsuccessful";
  }
};

export const getPivotListByCategoryId = async (
  page: number,
  per_page: number,
  industry_id: string,
  channel_key: string,
  categoryid: string
) => {
  try {
    const ret = await ServiceWrapper.doGet(
      `${api_base_url}pivot_attribute/list?page=${page}&per_page=${per_page}&industry_id=${industry_id}&channel_key=${channel_key ?? "K7pLWANJH2Yk3OYuJFka"
      }&category_id=${categoryid}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      return ret?.data?.data;
    } else return ret?.data?.message;
  } catch (error) {
    return "could'nt get the list";
  }
};

export const deletePivotData = async (Uid: string) => {
  try {
    const res = await ServiceWrapper.doDelete(
      `${api_base_url}pivot_attribute/${Uid}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res?.errorfound) toast.success("Deleted successfully");
    else toast.warning("Delete Unsuccessful")
  } catch (error) {
    toast.warning("Delete Unsuccessful")
    return "Delete Unsuccessful";
  }
};

export const updateDefaultVersion = async (Uid: string) => {
  try {
    const res = await ServiceWrapper.doPatch(
      `${api_base_url}pivot_attribute/${Uid}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res?.errorfound) toast.success("Updated successfully");
    else toast.warning("Update Unsuccessful")
  } catch (error) {
    toast.warning("Update Unsuccessful")
    return "Update Unsuccessful";
  }
};